import Alpine from "alpinejs"

;(window as any).Alpine = Alpine
Alpine.start()
